(function () {
  'use strict';

  angular.module('wsLrs.directives').
  // Adds infinite scroll capability, loading more data using the function
  // specified in the default attribute
  directive('wsInfiniteScroll', [function () {
    return {
      scope: {
        'wsInfiniteScroll': '='
      },
      link: function link(scope) {
        function register() {
          $(window).on('scroll', '', scrollAction);
        }
        function deregister() {
          $(window).off('scroll', '', scrollAction);
        }
        var scrollAction = _.throttle(function () {
          var scrollPosition = $(window).scrollTop(),
            lastScreenPosition = $(document).height() - $(window).height();
          if (scrollPosition >= lastScreenPosition - 2000) {
            var callbackResult = scope.wsInfiniteScroll();
            if (callbackResult === false) {
              deregister();
            }
          }
        }, 500);
        register();
        scope.$on('$destroy', function () {
          deregister();
        });
      }
    };
  }]);
})();
